import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhotoVideo } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import type { ImageLibraryModel } from '@models/types'

import useImageLibrary, { useRelations } from '@hooks/useImageLibrary'

const ImageLibraryListItem = (props: { imageLibrary: ImageLibraryModel }) => {
  const { imageLibrary } = props
  const {
    image_count, title,
  } = imageLibrary

  const imageLibraryPayload = useImageLibrary(imageLibrary)
  const {
    callbacks: { createOrEditImageLibrary },
  } = imageLibraryPayload

  const { agency, brand, coverImage } = useRelations(imageLibrary)

  // @ts-expect-error TS2339
  const ownerTitle = agency?.title || brand?.title

  return (
    <ListItem
      boxProps={{ borderBottom: '1px dashed', padding: 'large' }}
      onClick={() => createOrEditImageLibrary()}
      showAngleIcon
    >

      <Box
        alignItems="center"
        backgroundColor="whiteGrey"
        border="1px solid"
        borderColor="hoverGrey"
        borderRadius={5}
        height={40}
        justifyContent="center"
        marginRight="large"
        width={60}
      >
        {!coverImage && (
          <FontAwesomeIcon icon={faPhotoVideo} />
        )}

        {coverImage && (
          <Image
            borderRadius={5}
            height={40}
            width={60}
            // @ts-expect-error TS2339
            url={coverImage?.thumb_url}
          />
        )}
      </Box>

      <Box flexDirection="column" justifyContent="center">
        <Text fontSize="small" color="bodyFontLightColor">
          {title}
        </Text>

        <Text fontSize="xsmall" marginTop="medium" color="bodyFontLightColor">
          {ownerTitle}
        </Text>
      </Box>

      <Box display={['none', 'flex']} alignItems="center" justifyContent="flex-end" marginLeft="auto" width="auto">
        <Text color="bodyFontLightColor" fontSize="small" style={{ whiteSpace: 'nowrap' }}>
          {`${image_count} Image${image_count === 1 ? '' : 's'}`}
        </Text>
      </Box>
    </ListItem>
  )
}

export default ImageLibraryListItem
